let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g0K9S")).then(() => parcelRequire('9Ksvr'));